import { render, staticRenderFns } from "./Historydetails.vue?vue&type=template&id=5eb32fae"
import script from "./Historydetails.vue?vue&type=script&lang=js"
export * from "./Historydetails.vue?vue&type=script&lang=js"
import style0 from "./Historydetails.vue?vue&type=style&index=0&id=5eb32fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports